const common_pt = require('./common.json')
export default common_pt
